import React from "react";
import { Typography } from "components";
import { pocketMoniUrl } from "routes/routePaths";
import licenseImg from "assets/images/license-img.jpeg";

const AuthFooter = ({ positionAbsolute = true, showLicense = false }) => {
  const footerItems = [
    {
      label: "Company",
      link: "#",
    },
    {
      label: "About Us",
      link: "ourstory",
    },
    {
      label: "Support",
      link: "",
    },
    {
      label: "Terms & Condition",
      link: "#",
    },
    {
      label: "Privacy Policy",
      link: "#",
    },
  ];
  const currentDate = new Date();

  return (
    <div className={`container mb-4 ${positionAbsolute ? "auth-footer" : ""}`}>
      {showLicense && (
        <div className="d-flex justify-content-center mb-4">
          <img
            src={licenseImg}
            width="70%"
            alt="Licensed by CBN and insured by NDIC"
          />
        </div>
      )}

      <ul className="d-flex justify-content-around flex-wrap">
        {footerItems.map((footerItem, index) => (
          <li key={index}>
            <a
              href={`${pocketMoniUrl}${footerItem.link}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Typography state="grey" variant="body3">
                {footerItem.label}
              </Typography>
            </a>
          </li>
        ))}
      </ul>
      <Typography state="grey" variant="body3" className="text-center mt-1">
        Pocketmoni, inc. {currentDate.getFullYear()} © v2.0
      </Typography>
    </div>
  );
};

export default AuthFooter;
